<template>
  <div class="navbar-item-badge"><slot /></div>
</template>

<style>
.navbar-item-badge {
  @apply w-4 h-4 flex items-center justify-center;
  @apply text-[10px] leading-none font-bold;
  @apply bg-red-500 dark:bg-red-400 text-white;
  @apply rounded-full;
}
</style>
